import React from 'react'
//import { LaserProfile, OpenLaserProfile } from '@/app/products/[sku]/modelView/LaserProfile'

const formView = (defaultValues, value) => [
  {
    name: 'id',
    type: 'Hidden',
    className: 'col-span-12 row-span-1',
    defaultValue: defaultValues?.id,
  },

  {
    name: 'hatch_type',
    label: 'Hatch Type',
    type: 'Select',
    list: [
      { label: 'Line Hatch', value: 'line' },
      { label: 'Offset Fill Hatch', value: 'offset_fill' },
      { label: 'Offset In/Out Hatch', value: 'offset_in_out' },
      { label: 'Helix', value: 'helix' },
    ],
    className: 'col-span-12 row-span-1',
    menuPortalTarget: 'false',
    defaultValue: defaultValues?.hatch_type || 'line',
    clear: false,
    reset: false,
  },
  {
    name: 'laser_profile_id',
    label: 'Laser Profile',
    type: 'Select',
    api: {
      url: '/laserprofiles/',
      optionValue: (item) => ({
        value: item.id,
        label: item.name,
      }),
    },
    className: 'col-span-12 row-span-1',
    menuPortalTarget: 'false',
    clear: false,
    reset: false,
    defaultValue: defaultValues?.laser_profile_id || null,
  },
  /*{
        name: "add_hatch_laser_profile",
        label: "+",
        labelClassName: "opacity-0",
        className: "",
        type: "PopUp",
        module: LaserProfile,
        view: OpenLaserProfile,
        title: "Add Laser Profile (Hatch Pattern)",
        innerClassName: "w-[450px]",
        
        
    },*/
  {
    name: 'hatch_style',
    label: 'Hatch Style',
    type: 'Select',
    list: [
      { label: 'Unidirectional', value: 'unidirectional' },
      { label: 'Double Fill', value: 'double_fill' },
      { label: 'Serpentine', value: 'serpentine' },
      { label: 'Serpentine Connected', value: 'serpentine_connected' },
      { label: 'Hatch 2 Times', value: 'hatch_2_times' },
      { label: 'Hatch 3 Times', value: 'hatch_3_times' },
    ],
    className: 'col-span-12 row-span-1',
    menuPortalTarget: 'false',
    defaultValue: defaultValues?.hatch_style || 'serpentine',
    clear: false,
    reset: false,
    condition: (value) => value?.hatch_type === 'line',
  },
  {
    name: 'border_gap',
    label: 'Border Gap',
    placeholder: 'Gap',
    type: 'Number',
    className: 'col-span-4 row-span-1',
    defaultValue: defaultValues?.border_gap || '0',
    labelClassName: 'w-[300px]',
    clear: false,
    reset: false,
    condition: (value) => value?.hatch_type === 'line',
  },
  {
    name: 'is_apply_smoothing',
    label: 'Apply Smoothing',
    type: 'Checkbox',
    className: 'col-span-12 row-span-1 bg-white !px-0',
    labelClassName: 'hidden',
    defaultValue: defaultValues?.is_apply_smoothing !== undefined ? defaultValues?.is_apply_smoothing : true,
    clear: false,
    reset: false,
    disabled: (value) => value.border_gap < 0.0000000001,
    condition: (value) => value?.hatch_type === 'line',
  },
  {
    name: 'with_offset',
    label: 'With Offset',
    type: 'Checkbox',
    className: 'col-span-12 row-span-1 bg-white !px-0',
    labelClassName: 'hidden',
    defaultValue: defaultValues.with_offset !== undefined ? defaultValues.with_offset : true,
    clear: false,
    reset: false,
    disabled: (value) => value.border_gap < 0.0000000001,
    condition: (value) => value?.hatch_type === 'line',
  },

  {
    name: 'border_gap_direction',
    label: 'Border Gap Direction',
    type: 'Select',
    list: [
      { label: 'Outward', value: 'outward' },
      { label: 'Inward', value: 'inward' },
    ],
    className: 'col-span-12 row-span-1',
    menuPortalTarget: 'false',
    defaultValue: defaultValues?.border_gap_direction || 'inward',
    clear: false,
    reset: false,
    condition: (value) => value?.hatch_type === 'line',
  },
  {
    name: 'corner_style',
    label: 'Corner Style',
    type: 'Select',
    list: [
      { label: 'Smooth', value: 'smooth' },
      { label: 'Sharp', value: 'sharp' },
    ],
    className: 'col-span-12 row-span-1',
    menuPortalTarget: 'false',
    defaultValue: defaultValues?.corner_style || 'sharp',
    clear: false,
    reset: false,
    condition: (value) => value?.hatch_type === 'line',
  },
  {
    name: 'line_gap',
    label: 'Line Gap',
    placeholder: 'Gap',
    type: 'Number',
    className: 'col-span-4 row-span-1',
    defaultValue: defaultValues?.line_gap || '0.05',
    clear: false,
    reset: false,
    condition: (value) => value?.hatch_type === 'line',
  },
  {
    name: 'line_angle',
    label: 'Line Angle',
    placeholder: 'Angle',
    type: 'Number',
    className: 'col-span-4 row-span-1',
    defaultValue: defaultValues?.line_angle || '90',
    clear: false,
    reset: false,
    condition: (value) => value?.hatch_type === 'line',
  },
  {
    type: 'Header',
    className: 'col-span-4',
  },
  {
    name: 'base_x',
    label: 'Base X,Y',
    placeholder: 'X',
    type: 'Number',
    className: 'col-span-4 row-span-1',
    defaultValue: defaultValues?.base_x || defaultValues?.base?.x || '0.0',
    clear: false,
    reset: false,
    condition: (value) => value?.hatch_type === 'line',
  },
  {
    name: 'base_y',
    label: 'Base',
    placeholder: 'Y',
    type: 'Number',
    className: 'col-span-4 row-span-1',
    labelClassName: 'opacity-0',
    defaultValue: defaultValues?.base_y || defaultValues?.base?.y || '0.0',
    clear: false,
    reset: false,
    condition: (value) => value?.hatch_type === 'line',
  },
  {
    type: 'Header',
    className: 'col-span-4',
  },
  {
    name: 'individual_hatch_line_repeat_count',
    label: 'Individual Hatch Line Repeat Count',
    placeholder: 'Count',
    defaultValue: defaultValues?.individual_hatch_line_repeat_count || 1,
    type: 'Number',
    className: 'col-span-4 row-span-1',
    labelClassName: 'w-[300px]',
    clear: false,
    reset: false,
    condition: (value) => value?.hatch_type === 'line',
  },
  {
    name: 'is_incremental_rotation_enabled',
    label: 'Incremental Rotation Enabled',
    type: 'Checkbox',
    className: 'col-span-12 row-span-1 bg-white !px-0',
    labelClassName: 'hidden',
    defaultValue:
      defaultValues?.is_incremental_rotation_enabled !== undefined
        ? defaultValues?.is_incremental_rotation_enabled
        : false,
    clear: false,
    reset: false,
    condition: (value) => value?.hatch_type === 'line',
  },
  {
    name: 'incremental_start_angle',
    label: 'Incremental',
    placeholder: 'Angle',
    type: 'Number',
    className: 'col-span-4 row-span-1',
    defaultValue: defaultValues?.incremental_start_angle || '0.0',
    labelClassName: 'w-[300px]',
    hint: 'Start angle',
    clear: false,
    reset: false,
    condition: (value) => value?.hatch_type === 'line',
  },
  {
    name: 'incremental_step_angle',
    label: 'Incremental',
    placeholder: 'Angle',
    type: 'Number',
    className: 'col-span-4 row-span-1',
    defaultValue: defaultValues?.incremental_step_angle || '0.0',
    labelClassName: 'opacity-0',
    hint: 'Step angle',
    clear: false,
    reset: false,
    condition: (value) => value?.hatch_type === 'line',
  },
  {
    name: 'incremental_step_count',
    label: 'Incremental',
    placeholder: 'Count',
    type: 'Number',
    className: 'col-span-4 row-span-1',
    defaultValue: defaultValues?.incremental_step_count || 1,
    labelClassName: 'opacity-0',
    hint: 'Step count',
    clear: false,
    reset: false,
    condition: (value) => value?.hatch_type === 'line',
  },
]

export default formView
